import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { ConfigService } from './services/config.service';
import { EncryptDecryptService } from './services/encrypt-decrypt.service';
import { menuVertical } from './services/globals'
import { VariablesGlobales } from './services/globals.js';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'upgrade-project';
  menuVerti: boolean = menuVertical;

  constructor(private encdec: EncryptDecryptService, private http: HttpClient, public param: VariablesGlobales, config: ConfigService) {
    http.get('https://api2.sitederecrutement.com/Home/GetConfiguration?apikey=4Z387K3Xar78PaU53GrARtjkvUv23Hqj', { responseType: "text" }).subscribe(result => {
      if (result.includes('{Error:')) {
        console.error(result);
      }
      else {
        const obj = JSON.parse(this.encdec.getDecrypt(result));
        config.SetConfig(obj);
      }

    }, error => console.error(error));
  }

  ngOnInit(): void {
    localStorage.setItem('apikey', '4Z387K3Xar78PaU53GrARtjkvUv23Hqj');
  }

  onActivate(event) {
    // window.scroll(0,0);

    window.scroll({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });

    //or document.body.scrollTop = 0;
    //or document.querySelector('body').scrollTo(0,0)
  }
}
